<template>
  <div class="flex justify-between">
    <div class="flex items-center gap-2">
      <h4
        class="flex items-center justify-between text-3xl font-extrabold md:py-2"
      >
        {{ $t('general.price_table.title') }}
      </h4>

      <!-- Discount -->
      <div
        v-if="productRecommendedPrice && discount > 0"
        class="rounded-md bg-tertiary px-2 py-1"
      >
        <span
          id="discount-percentage"
          class="text-lg font-extrabold text-white"
        >
          - {{ displayableDiscount }}%
        </span>
      </div>
    </div>

    <button
      v-if="priceTableStore.hasFilters"
      type="button"
      class="flex items-center gap-1 rounded-md border border-gray-light p-1 px-2.5"
      @click="priceTableStore.togglePriceFilterPopup()"
    >
      <span class="flex items-center gap-2">
        <FontAwesomeIcon
          :icon="{ prefix: 'fas', iconName: 'sliders' }"
          class="h-4 w-4"
        />

        {{ $t('general.price_table.filters.open_filters') }}
      </span>
    </button>
  </div>
</template>

<script setup lang="ts">
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { usePriceTableStore } from '@/stores/PriceTable/PriceTableStore.ts';
import { computed, ComputedRef } from 'vue';

const priceTableStore = usePriceTableStore();

const productFinalPrice: ComputedRef<number> = computed(
  () => window.product_prices.final_price / 100
);
const productRecommendedPrice: ComputedRef<number> = computed(
  () => window.product_prices.base_price / 100
);
const discount: ComputedRef<number> = computed(
  () => window.product_prices.discount / 100
);

const displayableDiscount: ComputedRef<number> = computed(() => {
  return Math.round(
    window.product.discount_price
      ? ((productRecommendedPrice.value - productFinalPrice.value) /
          productRecommendedPrice.value) *
          100
      : discount.value
  );
});
</script>
